import { FC, MouseEvent, useState } from 'react';
import { Box, Button, Menu, MenuItem, Stack, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Add } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { getNightOrDayPalette } from '../../../../utils/getNightOrDayPalette';

type AddItemSelectProps = Readonly<{
	text: string;
	isLoading: boolean;
	options: { id: string; label: string }[];
	noItemsText: string;
	createText: string;
	onChange: (value: string) => void;
	onCreate: () => void;
}>;

export const AddItemSelect: FC<AddItemSelectProps> = ({ text, isLoading, options, noItemsText, createText, onChange, onCreate }) => {
	const theme = useTheme();
	const noAvailableOpportunities = !isLoading && (options.length || 0) === 0;

	const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);

	const handleSelectClick = (event: MouseEvent<HTMLElement>) => {
		if (!isLoading) {
			setMenuAnchorEl(event.currentTarget);
		}
	};

	return (
		<>
			<Button
				variant={'text'}
				color={'secondary'}
				startIcon={<Add />}
				sx={{
					position: 'relative',
					left: '-6px',
					height: 28,
				}}
				onClick={handleSelectClick}
			>
				{text}
			</Button>
			<Menu sx={{ maxHeight: 610 }} anchorEl={menuAnchorEl} open={menuAnchorEl != null} onClose={() => setMenuAnchorEl(null)}>
				{options.map(({ id, label }) => (
					<MenuItem
						key={id}
						sx={{
							gap: 1,
							margin: 0.5,
							borderRadius: 0.5,
						}}
						onClick={() => {
							setMenuAnchorEl(null);
							onChange(id);
						}}
					>
						<Box sx={{ maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis' }}>{label}</Box>
					</MenuItem>
				))}
				{noAvailableOpportunities && (
					<MenuItem
						disabled={true}
						sx={{
							gap: 1,
							margin: 0.5,
							borderRadius: 0.5,
						}}
					>
						{noItemsText}
					</MenuItem>
				)}
				<MenuItem
					sx={{
						backgroundColor: theme.palette.geekblue[0],
						color: theme.palette.primary[400],
						gap: 1,
						margin: 0.5,
						borderRadius: 0.5,
					}}
					onClick={() => {
						setMenuAnchorEl(null);
						onCreate();
					}}
				>
					<Stack direction={'row'} gap={1}>
						<AddIcon sx={{ color: (theme) => theme.palette[getNightOrDayPalette(theme)][900] }} />
						<Typography color={(theme) => theme.palette[getNightOrDayPalette(theme)][900]}>{createText}</Typography>
					</Stack>
				</MenuItem>
			</Menu>
		</>
	);
};
